// © Microsoft Corporation. All rights reserved.

import { placeholderImages } from "./images";

export default function avatarFallback(error) {
    error.target.onerror=null;
    error.target.src=placeholderImages.avatar;
}

export function contentImageFallback(error) {
    error.target.onerror = null;
    error.target.src = placeholderImages.content;
}